
  import {
    Vue,
    Component
  } from 'vue-property-decorator';
  import {
    AppModule
  } from '../../../store/modules/app';
  import {
    PermissionModule
  } from '../../../store/modules/permission'

  @Component({
    name: 'sidebar'
  })
  export default class Sidebar extends Vue {


    get routeList() {
      // console.log(PermissionModule.dynamicRoutes,'finally')
      return PermissionModule.dynamicRoutes;
    }

    get isCollapse() {
      return !AppModule.sidebar.opened;
    }

    private onlyOneChild(child: any) {
      const showChild = child.filter((item: any) => {
        return !item.hidden;
      })
      if (showChild.length <= 1 && showChild[0].meta.type === 'single') {
        return true;
      }
      return false;
    }
  }
